import { _baseGetFetch, ApiEnum } from './baseFetch'
import { getProducts, getApertures } from './usersAPI'
import { getProductTypes } from './productsAPI'

export const getInitialData = ({ cognitoSub, isEndUser, canAccessInstrumentTracking }) => {
  try {
    return Promise.all([
      getProductTypes(),
      ...(isEndUser ? [getProducts(cognitoSub)] : []),
      ...(canAccessInstrumentTracking ? [getApertures(cognitoSub)] : []),
    ]).then(([types, products, apertures]) => ({
      types: types?.data,
      ...(isEndUser && { products: products.data ? products.data : products }),
      ...(canAccessInstrumentTracking && { apertures: apertures?.data }),
    }))
  } catch (e) {
    console.log(e.message)
  }
}

export const getAccessLevels = () => {
  return _baseGetFetch(`/access-levels`, undefined, undefined)
}

export const getRegions = () => {
  return _baseGetFetch(`/regions`, undefined, undefined)
}

export const getLanguages = async () => {
  return _baseGetFetch(`/languages`, undefined, undefined)
}

export const getReportAccountTypes = (queryParams) => {
  return _baseGetFetch(`/report/account-types`, queryParams)
}
